import { Dates, TimelineComponentProps } from "../../omnia"
import { DomManager } from "../domManager"
import { FieldsVirtualized } from "./FieldsVirtualized"
import { ContextMenu } from "./Menu"
import { closePopup, createEventHandlers, setupScrollState } from "./shared"
import { TimelineProps } from "./types"

export function Timeline({ context, initState, apply }: TimelineProps) {

    // const [FieldsList, rootSelector] = [FieldsStd, ".tl-crops"]
    const [FieldsList, rootSelector] = [FieldsVirtualized, ".tl-crops .virtual-list"]

    const [state, setState] = React.useState(() => initState)

    React.useEffect(() => {
        setState(s => ({ ...s, viewState: initState.viewState }))
    }, [initState.vm.cropYear?.start])

    function saveState() {
        setState({ ...state })
    }

    const { vm, controller, viewState } = state

    vm.viewConfig.leftOffset = 200

    setupScrollState(state.viewState, vm)

    controller.setCurrentCropping = c => {

        if (viewState && (!viewState.dragging)) {

            const current = (c.mouseOver ? c : (viewState.currentItem == c ? null : viewState.currentItem))

            if (current != viewState.currentItem) {
                viewState.currentItem = current
                saveState()
            }

        }

    }

    const rootRef = React.useRef(null)

    const getRootElt = () => rootRef.current as HTMLElement

    React.useEffect(() => {

        const mgr = new DomManager(

            (stateChanged: boolean) => {

                apply && apply()

                if (stateChanged) {

                    state.viewState = {
                        ...state.viewState,
                        dragging: mgr.isDragging
                    }

                    saveState()

                }

            },
            rootRef.current,
            controller,
            rootSelector,
            ".tl-field > .content"
        )

        mgr.closePopup.onClick = false

        return () => mgr.dispose()

    }, [])

    const eventHandlers = createEventHandlers(context, state, saveState, getRootElt)

    const props: TimelineComponentProps = {
        vm,
        viewState,
        ...eventHandlers
    }

    return (

        <div
            ref={rootRef}
            className={"omnia-fields-timeline react react-virt"}
            onContextMenu={e => e.preventDefault()}
            onClick={e => closePopup(state, saveState)}>

            <div>

                <div className="tl">

                    <ContextMenu {...{ popup: state.controller.popupContext }} />

                    <Dates {...props} />

                    <FieldsList {...props} />

                </div>

            </div>
        </div>

    )


}
